const initializedGiftCardProducts = new WeakSet();

function initGiftCardProduct(root) {
  if (initializedGiftCardProducts.has(root)) return;
  initializedGiftCardProducts.add(root);

  const variants = JSON.parse(root.querySelector('[data-gift-card-variants]')?.textContent || '[]');
  const price = root.querySelector('[data-gift-card-price]');
  const selectionStatus = root.querySelector('[data-gift-card-selection-status]');
  const addButton = root.querySelector('[data-gift-card-add]');
  const card = root.querySelector('[data-gift-card-tilt]');
  const artworkTitle = root.querySelector('[data-gift-card-artwork-title]');
  const artworkInputs = root.querySelectorAll('[data-gift-card-artwork]');
  const currency = root.dataset.currency || 'GBP';
  const locale = document.documentElement.lang || 'en-GB';

  const updateVariant = (announce = false) => {
    const variantId = root.querySelector('[data-gift-card-variant-id]');
    const amount = root.querySelector('[data-gift-card-amount]:checked');
    const artwork = root.querySelector('[data-gift-card-artwork]:checked');
    const hasArtwork = artworkInputs.length > 0;
    const selected = variants.find((variant) =>
      variant.option1 === amount?.value &&
      (!hasArtwork || variant.option2 === artwork?.value) &&
      variant.available
    ) || variants.find((variant) =>
      variant.option1 === amount?.value &&
      (!hasArtwork || variant.option2 === artwork?.value)
    );

    if (!selected || !variantId || !price || !addButton) return;
    price.textContent = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: selected.price % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(selected.price / 100);
    addButton.disabled = !selected.available;
    addButton.textContent = selected.available ? 'ADD TO BAG' : 'SOLD OUT';
    variantId.value = String(selected.id);
    const title = artwork?.dataset.artworkTitle || selected.option2 || '';
    if (card) {
      const image = selected.featured_image?.src || card.dataset.giftCardFallbackArt;
      if (image && card.dataset.giftCardArt !== image) {
        card.style.setProperty('--gift-card-art', `url(${JSON.stringify(image)})`);
        card.dataset.giftCardArt = image;
      }
      card.setAttribute('aria-label', `${title} gift card artwork`);
    }
    if (artworkTitle) artworkTitle.textContent = title;
    if (announce && selectionStatus) {
      selectionStatus.textContent = `${amount?.value || price.textContent}${title ? `, ${title} design` : ''}. ${selected.available ? 'Available' : 'Sold out'}.`;
    }
    artworkInputs.forEach((input) => {
      input.closest('.lazy-oaf-gift-card-product__thumbnail')?.classList.toggle('is-active', input.checked);
    });
    root.dispatchEvent(new CustomEvent('gift-card:variant-change', { bubbles: true, detail: { variant: selected } }));
  };

  root.addEventListener('change', (event) => {
    if (event.target.matches('[data-gift-card-amount], [data-gift-card-artwork]')) updateVariant(true);
  });
  root.addEventListener('submit', () => updateVariant(), { capture: true });
  updateVariant();

  if (card && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    card.addEventListener('pointermove', (event) => {
      if (event.pointerType === 'touch') return;
      const rect = card.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      card.style.setProperty('--gift-card-tilt-x', `${(-y * 7).toFixed(2)}deg`);
      card.style.setProperty('--gift-card-tilt-y', `${(x * 7).toFixed(2)}deg`);
    });
    card.addEventListener('pointerleave', () => {
      card.style.removeProperty('--gift-card-tilt-x');
      card.style.removeProperty('--gift-card-tilt-y');
    });
  }
}

document.querySelectorAll('[data-gift-card-product]').forEach(initGiftCardProduct);

document.addEventListener('shopify:section:load', (event) => {
  if (!(event.target instanceof Element)) return;
  event.target.querySelectorAll('[data-gift-card-product]').forEach(initGiftCardProduct);
});
